import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AssignmentList from './List';
import AssignGroups from './Detail';
import { AssignmentProvider } from './context';
import AssignmentHistory from './AssignmentHistory';

// import AssignmentDetail from './Detail'; // For future detail/history pages
// import { AssignmentProvider } from './context'; // If you want to wrap detail pages

const Assignments: React.FC = () => {
  return (
    <Routes>
      <Route
        index
        element={<AssignmentList />}
      />
      <Route
        path=':id/assign'
        element={
          <AssignmentProvider>
            <AssignGroups />
          </AssignmentProvider>
        }
      />
      <Route
        path=':id/history'
        element={
          <AssignmentHistory />
        }
      />
      {/* Example for future detail/history routes:
      <Route path=":id" element={
        <AssignmentProvider>
          <AssignmentDetail />
        </AssignmentProvider>
      } />
      */}
      <Route
        path='*'
        element={<Navigate to='.' />}
      />
    </Routes>
  );
};

export default Assignments;
